/* eslint-disable import/prefer-default-export */

export const ERROR_MESSAGES = {
  EMAIL_ALREADY_USED: 'Email already used!',
  INVALID_DATA: 'Please enter valid data!',
  INCORRECT_PASSWORD: 'Please check your Password again!',
  USER_NOT_FOUND: 'The account does not exist!',
  GOOGLE_ACCOUNT: 'Try login with google account!',
  FACEBOOK_ACCOUNT: 'Try login with facebook account!',
  TRY_AGAIN: 'Try again later!',
};
